let forms = {
   query_users_registered: {
      icon: 'fa fa-pound-sign',
      title: 'Query By Date',
      subtitle: 'Query promo codes by Date',
      forms: [
         {
            type: 'select', class: 'col-12 col-md-5', model: 'status', filterable: true, clearable: true,
            multiple: false, max_tag_count: 1, options: [
               { val: 0, label: 'Pending Verification' },
               { val: 3, label: 'Verification Complete' },
            ], validation: '', label: 'Status'
         },
         {
            type: 'datepicker', form_type: 'daterange', format: 'dd-MM-yyyy', placement: 'bottom-end', placeholder: 'Select a date',
            model: 'duration', label: 'Query Date', class: 'col-12 col-md-7', validation: 'required'
         },
      ]
   },
   payment_verification: {
      icon: 'fa fa-pound-sign',
      title: 'Verify Payment',
      subtitle: 'Payment Verification',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'transaction_id',
            validation: 'required|min:6|max:16', label: 'Transaction ID',
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'amount',
            validation: 'min:1|max:16', label: 'Amount',
         },
         {
            type: 'select', class: 'col-12', model: 'payment_option', filterable: true, clearable: true,
            multiple: false, options: [], validation: '', label: 'Payment Type'
         },
      ]
   },
}

let tables = {
   users_registered: {
      icon: 'fa fa-users',
      title: 'Users Registered',
      table_fields: [
         { name: 'Application Code', align: 'l' },
         { name: 'Payment Receipt', align: 'l' },
         { name: 'Customer Type', align: 'l' },
         { name: 'Names', align: 'l' },
         { name: 'Company Name', align: 'l' },
         { name: 'Mobile Number', align: 'l' },
         { name: 'Email', align: 'l' },
         { name: 'Cards Requested', align: 'c' },
         { name: 'Created At', align: 'c' },
         { name: 'Actions', align: 'c' }
      ],
      search_fields: ["companyName", "name", "mobileNumber", "email", "paymentRef","payment_receipt"],
      row_data: [
         { type: 'text', field: 'paymentRef', class: 'bold' },
         { type: 'text', field: 'payment_receipt', class: 'bold' },
         { type: 'text', field: 'customerType', class: 'bold' },
         { type: 'text', field: 'name', class: 'bold' },
         { type: 'text', field: 'companyName', class: 'bold' },
         { type: 'text', field: 'mobileNumber', class: 'bold' },
         { type: 'text', field: 'email', class: 'bold' },
         { type: 'text', field: 'cards.length', class: 'bold center' },
         { type: 'date', field: 'created_at', class: 'center bolder small', format: 'DD-MM-YYYY HH:mm' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
               { type: 'menu', title: 'View', event: 'customer:view' },
               { type: 'menu', title: 'Verify Payment', event: 'customer:verify_payment' },
               // { type: 'menu', title: 'Edit', event: 'customer:edit', icon: 'fa-edit' },
               // { type: 'menu', title: 'Delete', event: 'customer:delete', icon: 'fa-trash-alt' },
            ]
         },
      ]
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}